import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../state/AppContextProvider';
import { ActionType } from '../state/GlobalState';

export function useDebugLink() {
  const [touchCount, setTouchCount] = useState(0);

  const { state, dispatch } = useContext(AppContext);

  const incTouchCount = (e) => {
    e.preventDefault();
    setTouchCount(touchCount + 1);
    if (touchCount > 7) {
      dispatch({ type: ActionType.ShowDebug, payload: true });
    }
  };

  return {
    incTouchCount: incTouchCount,
    touchCount: touchCount,
    showDebugLink: state.showDebug,
  };
}

export const DebugLink = () => {
  const { state } = useContext(AppContext);

  const link = state.isConnected ? '/debug' : '/logs';
  const name = state.isConnected ? 'Debug' : 'Logs';

  return <>{state.showDebug && <Link to={link}>{name}</Link>}</>;
};
